import React, {useEffect, useState} from "react";
import {Link, useLocation, Outlet, useNavigate} from "react-router-dom";
import styles from '../assets/css/mainPage.module.scss';
import {useAuthState} from "../context/AuthContext";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faTachometerAlt,
    faUser,
    faUserPlus,
    faUsers
} from '@fortawesome/free-solid-svg-icons';
import {
    AppBar, Button, Collapse, Dialog, DialogActions,
    DialogContent, DialogContentText,
    DialogTitle,
    Divider,
    Drawer,
    IconButton, List, ListItem, ListItemIcon, ListItemText, ListSubheader,
    Menu,
    MenuItem, Radio, TextField,
    Toolbar,
    Typography
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import {styled, useTheme} from '@mui/material/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import * as yup from "yup";
import {useFormik} from "formik";
import {Api} from "../../../utils/Api";
import {UserApi} from "../../../utils/UserApi";
import {ExpandLess, ExpandMore} from "@mui/icons-material";

const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));


const drawerWidth = 240;
const Main = props => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [open1, setOpen1] = useState(false);
    const [connection, setConnection] = useState(true);
    const theme = useTheme();
    const navigate = useNavigate();

    useEffect(() => {
        const response = () => {
            if (!connection)
                setConnection(true);
        }
        const error = () => {
            if (connection)
                setConnection(false);
        }
        setInterval(() => {
            Api.checkConnection(response, error);
        }, 15000)

        setTimeout(() => {
            let ele = document.getElementsByClassName("jss3");
            if (ele[0])
                [0].removeAttribute("class");
        }, 500);

        setInterval(() => {
            let ele = document.getElementsByClassName("jss3");
            if (ele[0])
                [0].removeAttribute("class");
        }, 5000)
    }, []);
    const validationSchema = yup.object({
        password: yup
            .string("رمز عبور جدید را وارد کنید.")
            .min(8, "طول رمز عبور حداقل باید 8 کارکتر باشد.")
            .required("وارد کردن رمز عبور الزامی ست."),
        passwordConfirmation: yup
            .string("رمز عبور را تکرار کنید.")
            .oneOf([yup.ref('password'), null], 'ورودی ها با یکدیگر یکسان نیستند.')
            .required("تکرار رمز عبور الزامی ست.")

    });
    const formik = useFormik({
        initialValues: {
            password: '', passwordConfirmation: ''

        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {

            const response = (result) => {
                handleClose1();
                formik.resetForm();
            }
            const error = (e) => {

            }
            let fd = new FormData();
            fd.append("password", values.password);
            await UserApi.updateMyPassword(fd, response, error);
        },
    });
    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    const classes = {
        root2: {}
        ,
        drawer: ""
    }
    const auth = useAuthState();

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    return <div className={classes.root2}>
        <AppBar position="static" className={styles.appBar}>
            <Toolbar>
                <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{mr: 2}}
                    onClick={() => {
                        handleDrawerOpen();
                    }}
                >
                    <MenuIcon/>
                </IconButton>
                <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                    Tehran Eshel
                </Typography>

                <div>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                    >
                        <AccountCircle/>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={() => {
                            handleClose();
                            navigate('/profile');
                        }}>پروفایل</MenuItem>
                        <MenuItem onClick={() => {
                            handleClose();
                            handleClickOpen1();
                        }}>تغییر رمز عبور</MenuItem>
                        <MenuItem onClick={() => {
                            auth.logout();
                        }}>خروج</MenuItem>
                    </Menu>
                </div>

            </Toolbar>
        </AppBar>
        <Drawer
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                },
            }}
            anchor="right"
            open={open}
            className={classes.drawer}
            onClose={handleDrawerClose}
        >
            <DrawerHeader>
                <IconButton onClick={handleDrawerClose}>
                    {theme.direction === 'rtl' ? <ChevronLeftIcon/> : <ChevronRightIcon/>}
                </IconButton>
            </DrawerHeader>
            <Divider/>
            <List
                sx={{width: '100%', maxWidth: 360}}
                component="nav"
                aria-labelledby="nested-list-subheader"
            >
                {menuItems.map((item, index) =>
                    <Item {...item} history={navigate} key={index}/>
                )}
            </List>
        </Drawer>
        <div style={{overflow: 'hidden'}}>
            <div className={styles.menuContainer}>
                <div>
                    <List
                        sx={{width: '100%', maxWidth: 360}}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                <Button className={styles.profileBtn}
                                        onClick={handleMenu} color={"info"} endIcon={<AccountCircleRoundedIcon/>}>
                                    <Radio
                                        checked
                                        color={connection ? "success" : "error"}
                                    />
                                    <div>
                                        {auth.user ? auth.user.name : ''}
                                    </div>

                                </Button>

                            </ListSubheader>
                        }
                    >
                        {menuItems.map((item, index) =>
                            <Item {...item} navigate={navigate} key={index}/>
                        )}
                    </List>
                </div>
            </div>
            <div className={styles.contents}>
                <Outlet/>
            </div>
        </div>
        <Dialog open={open1} onClose={handleClose1}>
            <form onSubmit={formik.handleSubmit}>
                <DialogTitle>تغییر رمز عبور</DialogTitle>
                <DialogContent style={{paddingTop: 20}}>
                    <DialogContentText>

                    </DialogContentText>
                    <div className={styles.inputContainer}>
                        <div className={styles.inputContainer}>

                            <TextField
                                fullWidth
                                id="password"
                                name="password"
                                label="رمز عبور"
                                type="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                                variant="outlined"
                                className={styles.textField}
                            />
                        </div>

                    </div>
                    <div className={styles.inputContainer}>

                        <TextField
                            fullWidth
                            id="passwordConfirmation"
                            name="passwordConfirmation"
                            label="رمز عبور"
                            type="password"
                            value={formik.values.passwordConfirmation}
                            onChange={formik.handleChange}
                            error={formik.touched.passwordConfirmation && Boolean(formik.errors.passwordConfirmation)}
                            helperText={formik.touched.passwordConfirmation && formik.errors.passwordConfirmation}
                            variant="outlined"
                            className={styles.textField}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose1} color={"error"}>انصراف</Button>
                    <Button type={"submit"}>ثبت</Button>
                </DialogActions>
            </form>
        </Dialog>
    </div>
};

const Item = props => {
    let {sub} = props;
    if (sub) {
        return <>
            <MenuItemWithSubItems {...props}/>
        </>;
    } else {
        return <>
            <SimpleMenuItem {...props}/>
        </>
    }


}
export default Main;


const menuItems = [
    {
        title: "داشبورد",
        to: "/admin",
        Icon: faTachometerAlt,
        activeOnlyWhenExact: true
    },
    {
        title: "کاربران",
        Icon: faUser,
        sub: [
            {
                title: "کاربران",
                to: "/admin/users",
                Icon: faUsers,
            }, {
                title: "کاربر جدید",
                to: "/admin/new-user",
                Icon: faUserPlus,
            }]

    },
    {
        title: "مقالات",
        Icon: faUser,
        sub: [
            {
                title: "لیست مقالات",
                to: "/admin/news",
                Icon: faUsers,
            },
            {
                title: "مقاله جدید",
                to: "/admin/new-news",
                Icon: faUserPlus,
            },
            {
                title: "لیست دسته بندی ها",
                to: "/admin/category",
                Icon: faUsers,
            },
            {
                title: "دسته جدید",
                to: "/admin/new-category",
                Icon: faUserPlus,
            },
            ]

    },
    {
        title: "خدمات",
        Icon: faUser,
        sub: [
            {
                title: "لیست خدمات",
                to: "/admin/service",
                Icon: faUsers,
            }, {
                title: "خدمت جدید",
                to: "/admin/new-service",
                Icon: faUserPlus,
            }]

    },

    {
        title: "مشتریان",
        to: "/admin/customer",
        Icon: faTachometerAlt,
        activeOnlyWhenExact: true
    },
    {
        title: "ویژگی",
        to: "/admin/benefit",
        Icon: faTachometerAlt,
        activeOnlyWhenExact: true
    },
    {
        title: "تماس",
        to: "/admin/contact",
        Icon: faTachometerAlt,
        activeOnlyWhenExact: true
    },
    {
        title: "درخواست های همکاری",
        to: "/admin/co-work",
        Icon: faTachometerAlt,
        activeOnlyWhenExact: true
    },
    {
        title: "تصاویر اسلایدر",
        to: "/admin/images",
        Icon: faTachometerAlt,
        activeOnlyWhenExact: true
    },
    {
        title: "تنظیمات",
        to: "/admin/setting",
        Icon: faTachometerAlt,
        activeOnlyWhenExact: true
    },
]


const SimpleMenuItem = ({Icon, title, to}) => {

    let location = useLocation();
    return <Link to={to} className={styles.link}>
        <ListItem onClick={(e) => {

        }} className={`${styles.menuItem} ${location.pathname === to ? styles.activeMenuItem : ''}`}>
            <ListItemIcon className={styles.menuIconContainer}>
                <FontAwesomeIcon icon={Icon}/>
            </ListItemIcon>
            <ListItemText primary={title} className={styles.menuTextContainer}/>
        </ListItem>
    </Link>;
};

const MenuItemWithSubItems = ({Icon, title, history, sub}) => {
    const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(!open);
    };
    return <>
        <ListItem onClick={handleClick} className={styles.menuItem}>
            <ListItemIcon className={styles.menuIconContainer}>
                <FontAwesomeIcon icon={Icon}/>
            </ListItemIcon>
            <ListItemText primary={title} className={styles.menuTextContainer}/>

            {open ? <ExpandLess/> : <ExpandMore/>}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit mountOnEnter>
            <div>
                <List component="div" disablePadding className={styles.subMenuContainer}>
                    {sub.map((item, index) => {
                        return <SubMenuItem {...item} history={history} key={index}/>
                    })}


                </List>
            </div>

        </Collapse>
    </>;
};

const SubMenuItem = ({Icon, title, to}) => {
    let location = useLocation();
    return <Link to={to} className={styles.link}>
        <ListItem sx={{pl: 4}} className={`${styles.menuItem} ${location.pathname === to ? styles.activeMenuItem : ''}`}
                  onClick={(e) => {
                      // navigate(to);
                  }}>
            <ListItemIcon className={styles.menuIconContainer}>
                <FontAwesomeIcon icon={Icon}/>
            </ListItemIcon>
            <ListItemText primary={title} className={styles.menuTextContainer}/>


        </ListItem>
    </Link>
}